export default {
	'main.openHistoryAndTodoDrawer': 'Відкрити історію та справи',
	'main.closeHistoryAndTodoDrawer': 'Закрити історію та справи',
};
